import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading, login } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-[60vh] grid place-items-center px-4" data-testid="auth-gate">
        <div className="text-center max-w-md space-y-4">
          <h2 className="font-serif text-2xl font-semibold">Please sign in to continue</h2>
          <p className="text-muted-foreground">Sign in with Google to book worships, view your bookings and manage your account.</p>
          <button onClick={login} data-testid="gate-login-button" className="px-6 py-3 rounded-full bg-primary text-primary-foreground font-medium hover:bg-primary/90">
            Sign in with Google
          </button>
        </div>
      </div>
    );
  }

  if (adminOnly && !user.roles?.includes("admin")) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
}
